/** @format */

export const flatArr = (arr: any[], children = 'children'): any[] => {
	return arr.reduce((count, itm) => {
		if (itm[children]) {
			return [...count, itm, ...flatArr(itm[children], children)];
		} else {
			return [...count, itm];
		}
	}, []);
};
